export default __webpack_public_path__ + "static/media/blue-air-balloon.2b671283.svg";